import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';

import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {PasswordInputComponent} from "./controls/password-input/password-input.component";
import {LoginComponent} from './pages/login/login.component';
import {MainComponent} from './pages/main/main.component';
import {MatMenuModule} from "@angular/material/menu";
import {MatSortModule} from "@angular/material/sort";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {MatDividerModule} from "@angular/material/divider";
import {MatTooltipModule} from "@angular/material/tooltip";
import {MatTableModule} from "@angular/material/table";
import {MatPaginatorModule} from "@angular/material/paginator";
import {MatProgressSpinnerModule} from "@angular/material/progress-spinner";
import {MatProgressBarModule} from "@angular/material/progress-bar";
import {MatListModule} from "@angular/material/list";
import {MatInputModule} from "@angular/material/input";
import {MatIconModule} from "@angular/material/icon";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatExpansionModule} from "@angular/material/expansion";
import {MatDialogModule} from "@angular/material/dialog";
import {MatNativeDateModule} from "@angular/material/core";
import {MatDatepickerModule} from "@angular/material/datepicker";
import {MatCheckboxModule} from "@angular/material/checkbox";
import {MatCardModule} from "@angular/material/card";
import {MatButtonModule} from "@angular/material/button";
import {MatRadioModule} from "@angular/material/radio";
import {MatSelectModule} from "@angular/material/select";
import {MatSlideToggleModule} from "@angular/material/slide-toggle";
import {MatSnackBarModule} from "@angular/material/snack-bar";
import {HeaderComponent} from './controls/header/header.component';
import {AuthenticatedGuard} from "./guards/authenticated.guard";
import {AlertDialogComponent} from "./dialogs/alert-dialog/alert-dialog.component";
import {ConfirmDialogComponent} from "./dialogs/confirm-dialog/confirm-dialog.component";
import {HTTP_INTERCEPTORS, HttpClientModule} from "@angular/common/http";
import {ErrorInterceptor} from "./interceptors/error.interceptor";
import {TokenInterceptor} from "./interceptors/token.interceptor";
import {UnauthorizedInterceptor} from "./interceptors/unauthorized.interceptor";
import {ForgotPasswordComponent} from "./pages/forgot-password/forgot-password.component";
import {ResetPasswordComponent} from "./pages/reset-password/reset-password.component";
import { KitsComponent } from './pages/kits/kits.component';
import { KitStatusDialogComponent } from './dialogs/kit-status-dialog/kit-status-dialog.component';
import { OrdersComponent } from './pages/orders/orders.component';
import { OrderStatusDialogComponent } from './dialogs/order-status-dialog/order-status-dialog.component';
import { InstitutionsComponent } from './pages/institutions/institutions.component';
import { InstitutionComponent } from './pages/institution/institution.component';
import { InstOrdersComponent } from './pages/institution/inst-orders/inst-orders.component';
import { InstOrderComponent } from './pages/institution/inst-order/inst-order.component';
import {NgxMaterialTimepickerModule} from "ngx-material-timepicker";
import { PromosComponent } from './pages/promos/promos.component';
import { PromoComponent } from './pages/promos/promo/promo.component';
import { BackendUsersComponent } from './pages/backend-users/backend-users.component';
import { SiteUsersComponent } from './pages/site-users/site-users.component';
import { SiteUserComponent } from './pages/site-user/site-user.component';
import { BackendUserComponent } from './pages/backend-user/backend-user.component';
import { OrderInfoComponent } from './controls/order-info/order-info.component';
import {XLinkComponent} from "./controls/xlink/xlink.component";
import {FedexTrackingComponent} from "./controls/fedex-tracking/fedex-tracking.component";
import { PhonePipe } from './pipes/phone.pipe';

@NgModule({
    declarations: [
        AppComponent,
        PasswordInputComponent,
        AlertDialogComponent,
        ConfirmDialogComponent,
        LoginComponent,
        MainComponent,
        HeaderComponent,
        ForgotPasswordComponent,
        ResetPasswordComponent,
        KitsComponent,
        KitStatusDialogComponent,
        OrdersComponent,
        OrderStatusDialogComponent,
        InstitutionsComponent,
        InstitutionComponent,
        InstOrdersComponent,
        InstOrderComponent,
        PromosComponent,
        PromoComponent,
        BackendUsersComponent,
        SiteUsersComponent,
        SiteUserComponent,
        BackendUserComponent,
        OrderInfoComponent,
        XLinkComponent,
        FedexTrackingComponent,
        PhonePipe
    ],
    imports: [
        HttpClientModule,
        BrowserModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        MatButtonModule,
        MatCardModule,
        MatCheckboxModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatDialogModule,
        MatExpansionModule,
        MatFormFieldModule,
        MatIconModule,
        MatInputModule,
        MatListModule,
        MatPaginatorModule,
        MatProgressBarModule,
        MatProgressSpinnerModule,
        MatRadioModule,
        MatSelectModule,
        MatSlideToggleModule,
        MatSnackBarModule,
        MatTableModule,
        MatTooltipModule,
        MatDividerModule,
        ReactiveFormsModule,
        MatSortModule,
        MatMenuModule,
        FormsModule,
        NgxMaterialTimepickerModule
    ],
    providers: [
        AuthenticatedGuard,
        {provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true},
        {provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true},
        {provide: HTTP_INTERCEPTORS, useClass: UnauthorizedInterceptor, multi: true},
    ],
    bootstrap: [AppComponent]
})
export class AppModule {
}
